import { Link } from "react-router-dom";
import { Wordmark } from "@/components/brand/logo_swiprent";

const COLS = [
  {
    title: "Support",
    links: [
      { label: "Help centre", href: "mailto:info@swiprent.com" },
      { label: "Report a listing", href: "mailto:info@swiprent.com" },
      { label: "Terms of service", to: "/terms" },
      { label: "Privacy policy", to: "/privacy" },
    ],
  },
  {
    title: "Listing",
    links: [
      { label: "List your place", to: "/lister" },
      { label: "Browse renters", to: "/lister/browse" },
      { label: "Pricing for listers", to: "/pricing" },
    ],
  },
  {
    title: "SwipRent",
    links: [
      { label: "How it works", to: "/how-it-works" },
      { label: "Swipe homes", to: "/swipe" },
      { label: "Map search", to: "/map" },
      { label: "Matches", to: "/matches" },
      { label: "Pricing", to: "/pricing" },
    ],
  },
];

export default function FooterMain() {
  return (
    <footer className="border-t border-night-line bg-night">
      {/* Wordmark leads the footer. */}
      <div className="mx-auto max-w-[1360px] px-6 pt-10 lg:px-10">
        <Wordmark onDark size={26} />
      </div>
      <div className="mx-auto grid max-w-[1360px] gap-10 px-6 py-12 sm:grid-cols-3 lg:px-10">
        {COLS.map((col) => (
          <div key={col.title}>
            <h4 className="mb-4 text-sm font-semibold text-night-text">{col.title}</h4>
            <ul className="space-y-3">
              {col.links.map((l) => (
                <li key={l.label}>
                  {l.to ? (
                    <Link to={l.to} className="text-sm text-night-sub transition hover:text-night-text hover:underline">
                      {l.label}
                    </Link>
                  ) : (
                    <a href={l.href} className="text-sm text-night-sub transition hover:text-night-text hover:underline">
                      {l.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-night-line">
        <div className="mx-auto flex max-w-[1360px] flex-col items-start justify-between gap-3 px-6 py-6 text-sm text-night-sub sm:flex-row sm:items-center lg:px-10">
          <p>
            © {new Date().getFullYear()} SwipRent · Powered by{" "}
            <a
              href="https://www.averoan.com"
              target="_blank"
              rel="noreferrer"
              className="text-night-text transition hover:underline"
            >
              Averoan Technologies Inc.
            </a>
          </p>
          <p className="flex items-center gap-4">
            <Link to="/terms" className="transition hover:text-night-text hover:underline">Terms</Link>
            <Link to="/privacy" className="transition hover:text-night-text hover:underline">Privacy</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
